import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {fetchColoresGet, fetchListaUsos, fetchCondiciones} from '../../../actions';
import Alert from '../../../components/Alert';
import getConditionsProform from '../../../utils/getConditionsProform';
import getColorsProform from '../../../utils/getColorsProform';
import editConditions from '../../../utils/editConditions';
//import editColors from '../../../utils/editColors';
import assignColors from '../../../utils/assignColors';
import editObservations from '../../../utils/editObservations';
import updateProforma from '../../../utils/updateProforma';
import ErrorUIComponent from '../../../utils/ErrorUIComponent';
import {FadeLoader} from 'react-spinners';


class Observaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editProform: '',
            editObs: '',
            observaciones: '',
            condicionesAntigua: [],
            condicionesNueva: [],
            coloresAntiguo: [],
            coloresNuevo: [['', '']],
            uso: '',
            capacitacion: false,
            hasError: false,
            muestraLoad: 'none',
            coloresXproforma: [],
        };
        this.editObs = this.editObs.bind(this);
        this.closeObs = this.closeObs.bind(this);
        this.handleChangeObs = this.handleChangeObs.bind(this);
        this.changeObservations = this.changeObservations.bind(this);
        this.handleChangeColor = this.handleChangeColor.bind(this);
        this.changeChecklist = this.changeChecklist.bind(this);
        this.changeColors = this.changeColors.bind(this);
        this.addColor = this.addColor.bind(this);
        this.removeColor = this.removeColor.bind(this);
        this.handleChangeUso = this.handleChangeUso.bind(this);
        this.changeUso = this.changeUso.bind(this);
    }

    componentDidMount() {
        this.setState({muestraLoad: 'block'});

        const {fdvID, proformas} = this.props;
        this.props.fetchListaUsos(proformas);
        this.props.fetchCondiciones(this.props.fdv[0].codAreaVta);
        if (proformas.length > 0) {
            this.props.fetchColoresGet(proformas[0].codAreaVta, proformas[0].codFamiliaVeh, proformas[0].codMarca);

        }


        getConditionsProform(fdvID, proformas)
            .then((response) => {
                if (response.indexOf('error') >= 0) {
                    this.setState({hasError: true});
                } else { 
                    this.setState({condicionesAntigua: response});
                }
            });

        getColorsProform(fdvID, proformas)
            .then((response) => {
                if (response.indexOf('error') >= 0) {
                    this.setState({hasError: true});
                } else {
                    this.setState({coloresAntiguo: response}, () => {
                        proformas.forEach((entity, index) => {
                            let newColores = _.filter(this.state.coloresAntiguo, _.property(entity.numProfVeh))[0][entity.numProfVeh];
                            newColores.map((items, index) => {
                                return items = Object.assign(items,
                                    {numProfVeh: entity.numProfVeh, index: index}
                                );
                            });
                            this.setState({
                                coloresXproforma: [...this.state.coloresXproforma, ...newColores]
                            });
                        });
                    });
                }
            });

        this.setState({muestraLoad: 'none'});

    }


    editObs() {
        this.setState({editObs: true, observaciones: this.props.fdv[0].obsFichaVtaVeh});
    }

    closeObs() {
        this.setState({editObs: false});
    }

    handleChangeObs(e) {
        this.setState({observaciones: e.target.value});
    }

    changeObservations() {
        const fdv = this.props.fdv[0];
        const {fdvID} = this.props;
        const codCia = fdv.codCia;
        const codAreaVta = fdv.codAreaVta;
        const codFilial = fdv.codFilial;
        const codCliente = fdv.codClie;
        const codTipoFicha = fdv.codTipoFichaVtaVeh;
        const codMoneda = fdv.codMonedaFichaVtaVeh;
        const codVendedor = fdv.vendedor;
        const codTipoPago = fdv.codTipoPago;
        const {observaciones} = this.state;
        editObservations(fdvID, codCia, codAreaVta, codFilial, codCliente,
            codTipoFicha, codMoneda, codVendedor, codTipoPago, observaciones)
            .then(() => this.props.fetchFichaVenta(fdvID))
            .then(this.setState({editObs: false}));
    }

    showEdit(nroProforma, codAVtaFamUso, indSoliCapacitacion) {
        var data = document.getElementsByClassName('0');
        for (var i = 0; i < data.length; i++) {
            if (data.style !== null) {
                // data.style.display = 'none';
            }

        }
        const condProf = _.filter(
            this.state.condicionesAntigua, _.property(nroProforma)
        )[0][nroProforma].map(checkProforma => checkProforma.codChek);
        const indCapa = indSoliCapacitacion === '1';
        const colorProf = _.filter(
            this.state.coloresAntiguo, _.property(nroProforma)
        )[0][nroProforma].map(
            colorProforma => [colorProforma.codColorFabricaVeh, colorProforma.codFiveProfColo]);
        this.setState(
            {
                editProform: nroProforma,
                condicionesNueva: condProf,
                coloresNuevo: colorProf,
                uso: codAVtaFamUso,
                capacitacion: indCapa
            }
        );
        if (colorProf.length === 0) {
            this.setState({coloresNuevo: [['', '']]});
        }
    }

    closeEdit() {
        this.setState({editProform: ''});
    }

    conditionsSelected(codChek) {
        const {condicionesNueva} = this.state;
        if (condicionesNueva.indexOf(codChek) >= 0) {
            this.setState({
                condicionesNueva: condicionesNueva.filter(cod => cod !== codChek),
            }, () => {
                console.log('condicionesNueva', condicionesNueva)
            });
        } else {
            this.setState({
                condicionesNueva: [codChek, ...this.state.condicionesNueva],
            }, () => {
                console.log('condicionesNueva', condicionesNueva)
            });
        }


    }
    // <I> 89394  ECUBAS
    changeChecklist(nroProforma, codAreaVta) {
        const {condicionesNueva} = this.state;
        const {fdvID} = this.props;
        const {proformas} = this.props;
        const codFiveChecksProformaList = _.filter(
            this.state.condicionesAntigua, _.property(nroProforma)
        )[0][nroProforma];//.map(checkProforma => checkProforma.codFiveProfChek)[0];
        const condicionesAntigua = _.filter(
            this.state.condicionesAntigua, _.property(nroProforma)
        )[0][nroProforma].map(checkProforma => checkProforma.codChek);
        const condicionesActualizadas = [];
        
        condicionesNueva.forEach((condicion) => {
            if (!(condicionesAntigua.indexOf(condicion) >= 0)) {
                condicionesActualizadas.push({codColorFabricaVeh: 'N', codCondicion: condicion});
            }
            this.setState({cambiaCondicion: 1});
        });
        condicionesAntigua.forEach((condicion) => {
            if (!(condicionesNueva.filter(obj => obj === condicion) > 0)) { 
              const element =  codFiveChecksProformaList.
                            filter(task => task.codChek  === condicion )[0].codFiveProfChek;  
                        condicionesActualizadas.push(
                            {indInactivo: 'S', codCondicion: condicion, 
                            codProformaCondicion: element}
                        );
            }
            this.setState({cambiaCondicion: 1});
        });
 
        //if(this.state.cambiaCondicion !== undefined  && this.state.cambiaCondicion !== undefined){
            editConditions(fdvID, nroProforma, condicionesActualizadas, codAreaVta)
                .then(() =>
                    getConditionsProform(fdvID, proformas)
                        .then(response => this.setState({condicionesAntigua: response}))
                );
       // }

        /*editConditions(fdvID, nroProforma, condicionesActualizadas, codAreaVta)
            .then(() =>
                getConditionsProform(fdvID, proformas)
                    .then(response => this.setState({condicionesAntigua: response}))
            );*/
    }
    // <F> 89394  ECUBAS

    handleChangeColor(e, index) {
        this.setState({
            coloresXproforma: this.state.coloresXproforma.map((items) => {
                console.log('items', items);
                console.log('otro', items.index + ' ===' + index);
                if (items.index === index) {
                    return Object.assign(items, {codColorFabricaVeh: e.target.value});
                } else {
                    return items;
                }
            })
        });
        /*REQ-86364*/
        this.setState({
            contColor: 1
        });
        /*REQ-86364*/
    }

    addColor(numProfVeh) {
        let newObjt = {
            numProfVeh: numProfVeh,
            codColorFabricaVeh: '',
            codColorSunarp: '',
            codFiveProfColo: '',
            desColorFabricaVeh: '',
            desColorSunarp: '',
            index: this.state.coloresXproforma.length + 1
        };
        this.setState({coloresXproforma: [...this.state.coloresXproforma, newObjt]})
    }

    removeColor(event, index) {
        this.setState({coloresXproforma: this.state.coloresXproforma.filter(entity => entity.index !== index)});
    }

    changeColors(nroProforma) {
        const {fdvID, proformas} = this.props;
        let insertColor = this.state.coloresXproforma.filter(entity => entity.numProfVeh === nroProforma).map(entity => {
            return entity.codColorFabricaVeh
        });
        console.log('insertColor', insertColor);
        /*REQ-86364*/
        if (this.state.contColor != null) {
            assignColors(fdvID, nroProforma, insertColor)
                .then(() =>
                    getColorsProform(fdvID, proformas)
                        .then(response => this.setState({ coloresAntiguo: response }))
                );
        }
        /*REQ-86364*/
    }

    handleChangeUso(e) {
        this.setState({uso: e.target.value});
        /*REQ-86364*/
        this.setState({
            contUso: 1
        })
        /*REQ-86364*/
    }

    changeUso(nroProforma) {
        const {fdvID} = this.props;
        const capacitacion = this.state.capacitacion ? 1 : 0;
        const uso = parseInt(this.state.uso, 10);
        /*REQ-86364*/
        if (this.state.contUso != null) {
            updateProforma(fdvID, nroProforma, uso, capacitacion)
                .then(() => this.props.fetchProformas(fdvID));
        }
        /*REQ-86364*/
    }

    updateInfo(nroProforma, codAreaVta) {
        Promise.all([
            this.changeChecklist(nroProforma, codAreaVta),
            this.changeColors(nroProforma),
            this.changeUso(nroProforma),
        ]).then(() => this.setState({editProform: ''}));
    }

    render() {
        const {condiciones, colores, usos, codEstadoFichaVtaVeh} = this.props;
        const {condicionesNueva, capacitacion, coloresNuevo, uso, hasError} = this.state;
        const notEditable = (['E', 'I', 'V'].indexOf(codEstadoFichaVtaVeh) >= 0);
        // || this.props.autorizaciones[2].codAprobFichaVtaAut === 'A';

        if (hasError) {
            return (
                <Alert type='alert-warning' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
                    <p>Hubo un error al obtener información del servicio</p>
                </Alert>
            );
        }

        if (!this.state.condicionesAntigua.length ||
            !this.state.coloresAntiguo.length ||
            !this.props.usos || !this.props.condiciones) {
            return false;
        }

        return (
            <ErrorUIComponent>
                <section className='fdv-section' id='observaciones'>
                    <header className='fdv-section-head'>
                        <h5 className='fdv-section-title'>Observaciones</h5>
                        {notEditable ?
                            <div className='fdv-section-actions'>
                                <button className='btn-clean pull-right' type='button'>
                                    <i className='ion-edit c-gray'/>
                                </button>
                            </div> :
                            <div className='fdv-section-actions'>
                                <button className='btn-clean pull-right' data-permisos='ind_editar_observaciones'
                                        type='button'
                                        onClick={(e) => this.props.handlePermissions(e) && this.editObs()}>
                                    <i className='ion-edit h6 c-cyan'/>
                                </button>
                            </div>
                        }
                    </header>
                    <div className={this.state.editObs ? 'js-hide' : 'js-open'}>
                        <p>{this.props.fdv[0].obsFichaVtaVeh}</p>
                    </div>
                    <div className={this.state.editObs ? 'js-open' : 'js-hide'}>
                        <div className='form-group'>
                            <textarea className='form-control' maxLength='300' value={this.state.observaciones}
                                      onChange={this.handleChangeObs}/>
                        </div>
                        <div className='clearfix'>
                            <button className='btn btn-return pull-left' type='button'
                                    onClick={this.closeObs}>Cancelar
                            </button>
                            <button className='btn btn-primary pull-right' type='button'
                                    onClick={this.changeObservations}>Guardar
                            </button>
                        </div>
                    </div>

                    <header className='fdv-section-head'>
                        <h5 className='fdv-section-title'>Condiciones de Entrega</h5>
                    </header>
                    {this.props.proformas.map(proforma => (
                        <div className='card card-plain card-lg' key={proforma.numProfVeh}>
                            {notEditable ?
                                <div className='fdv-section-actions'>
                                    <button className='btn-clean pull-right' type='button'>
                                        <i className='ion-edit c-gray'/>
                                    </button>
                                </div> :
                                <div className='card-lg-action'>
                                    <button className='btn-clean' type='button'
                                            onClick={() => this.showEdit(proforma.numProfVeh, proforma.codAVtaFamUso, proforma.indSoliCapacitacion)}>
                                        <i className='ion-edit h6 c-cyan'/>
                                    </button>
                                </div>
                            }
                            <h4 className='fBold'>Proforma - {proforma.numProfVeh}</h4>
                            <div
                                className={`js-open ${this.state.editProform === proforma.numProfVeh ? 'js-hide' : ''}`}
                                id='viewObsTab'>
                                <ul className='list list-check'>
                                    {_.filter(
                                        this.state.condicionesAntigua, _.property(proforma.numProfVeh)
                                    )[0][proforma.numProfVeh].map(checkProforma =>
                                        <li key={checkProforma.codFiveProfChek}>{checkProforma.desChek}</li>
                                    )}
                                    
                                </ul>
                                <div className='row row-features'>
                                    <div className='col-md-6'>
                                        <p className='labelInfo'>Color(es)</p>
                                        {_.filter(
                                            this.state.coloresAntiguo, _.property(proforma.numProfVeh)
                                        )[0][proforma.numProfVeh].map(
                                            ({desColorFabricaVeh}) => desColorFabricaVeh
                                        ).join(', ')}
                                    </div>
                                    <div className='col-md-6'>
                                        <p className='labelInfo'>Uso</p>
                                        {_.filter(usos, _.property(proforma.numProfVeh))[0][proforma.numProfVeh]
                                            .filter(({desUsoVeh, codAVtaFamUso}) => (
                                                codAVtaFamUso === proforma.codAVtaFamUso.toString() ? desUsoVeh : false))
                                            .map(({desUsoVeh}) => desUsoVeh)
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={this.state.editProform === proforma.numProfVeh ? 'js-open' : 'js-hide'}
                                 id='editObsTab'>
                                <form>
                                    {condiciones.checkCondicion.map(({codChek, desChek}) => (
                                        <div className='checkbox' key={desChek}>
                                            <label>
                                                <input
                                                    type='checkbox'
                                                    checked={condicionesNueva.indexOf(codChek) >= 0}
                                                />
                                                <div className='checkbox-skin'
                                                     onClick={() => this.conditionsSelected(codChek)}/>
                                                {desChek}
                                            </label>
                                        </div>
                                    ))}
                                    

                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='form-group' id='colors-group'>
                                                {
                                                    this.state.coloresXproforma.filter(entity => entity.numProfVeh === proforma.numProfVeh)
                                                    && this.state.coloresXproforma.filter(entity => entity.numProfVeh === proforma.numProfVeh).map((element, index) => {
                                                            return (
                                                                <div className='info' id='color-group' key={index}>
                                                                    <label htmlFor='color' className='labelInfo'>
                                                                        <button className={`btn-clean ${index}`}
                                                                                type='button'
                                                                                onClick={e => this.removeColor(e, index)}>
                                                                            <i className='ion-ios-minus-outline c-cyan mr-2'/>
                                                                        </button>
                                                                        Color
                                                                    </label>
                                                                    {proforma.codFamiliaVeh === '1' ? (
                                                                        <div className='form-group'>Para automoviles no se
                                                                            puede editar colores.</div>
                                                                    ) : (
                                                                        <div className='form-group'>
                                                                            <div className='select selectColor'>
                                                                                <select
                                                                                    value={element.codColorFabricaVeh}
                                                                                    className='form-control'
                                                                                    onChange={(event) => this.handleChangeColor(event, element.index)}
                                                                                >
                                                                                    <option value=''>Selecciona un color
                                                                                    </option>
                                                                                    {
                                                                                        this.props.colores.map(color =>
                                                                                            <option key={color.codPintura}
                                                                                                    value={`${color.codPintura}`}>{color.color}</option>
                                                                                        )
                                                                                    }
                                                                                </select>
                                                                                <div className='select-control-icon'><i
                                                                                    className='ion-chevron-down'/></div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                </div>
                                                            )
                                                        }
                                                    )}
                                                {proforma.codFamiliaVeh === '1' ? null : (
                                                    <button className='btn btn-iconLeft btn-link pull-right'
                                                            onClick={() => this.addColor(proforma.numProfVeh)}
                                                            type='button'>
                                                        <i className='ion-plus'/><span>Agregar color</span>
                                                    </button>
                                                )}

                                            </div>

                                        </div>
                                        <div className='col-md-6 col-xs-12'>
                                            {_.filter(usos, _.property(proforma.numProfVeh)).length === 0 ? (
                                                null
                                            ) : (
                                                <div className='info'>
                                                    <label htmlFor='uso' className='labelInfo'>Uso</label>
                                                    <div className='select'>
                                                        <select className='form-control' value={uso}
                                                                onChange={this.handleChangeUso}>
                                                            <option value=''>Tipo de uso</option>
                                                            {_.filter(
                                                                usos, _.property(proforma.numProfVeh)
                                                            )[0][proforma.numProfVeh].map(data =>
                                                                <option value={data.codAVtaFamUso}
                                                                        key={data.codAVtaFamUso}>
                                                                    {data.desUsoVeh}
                                                                </option>
                                                            )}
                                                        </select>
                                                        <div className='select-control-icon'><i
                                                            className='ion-chevron-down'/></div>
                                                    </div>
                                                </div>
                                            )
                                            }
                                        </div>
                                    </div>
                                    <div className='btnActions'>
                                        <button className='btn btn-return' type='button'
                                                onClick={() => this.closeEdit(proforma.numProfVeh)}>Cancelar
                                        </button>
                                        <button className='btn btn-primary' type='button'
                                                onClick={() => this.updateInfo(proforma.numProfVeh, proforma.codAreaVta)}>Guardar
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    ))}
                </section>

                <div className='modal extraFilter' role='dialog' data-backdrop='static'
                     style={{display: this.state.muestraLoad}}>
                    <div className='modal-dialog modal-sm' role='document'>
                        <FadeLoader color={'#F8A14A'} loading/>
                    </div>
                </div>

                {
                    this.props.colores && this.props.colores.error ?
                        <Alert type='alert-danger' icon='ion-alert-circled'>
                            <p>Hubo un error con el servicio de listar colores</p>
                        </Alert> : null
                }

                {
                    this.props.usos && this.props.usos.error ?
                        <Alert type='alert-danger' icon='ion-alert-circled'>
                            <p>Hubo un error con el servicio de listar usos</p>
                        </Alert> : null
                }

                {
                    this.props.condiciones && this.props.condiciones.error ?
                        <Alert type='alert-danger' icon='ion-alert-circled'>
                            <p>Hubo un error con el servicio de listar condiciones</p>
                        </Alert> : null
                }

            </ErrorUIComponent>
        );
    }
}

Observaciones.defaultProps = {proformas: [{}], fdv: [{}]};

function mapStateToProps(state) {
    return {
        colores: state.colores,
        usos: state.usos,
        condiciones: state.condiciones,
    };
}

export default connect(mapStateToProps, {fetchColoresGet, fetchListaUsos, fetchCondiciones})(Observaciones);


// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/Observaciones.js